<div style="font-size: 16px; font-weight: 600; margin-bottom: 20px;">Change Password</div>

<div class="field">
    <div>Current Password:</div>
    <p-password [(ngModel)]="parent.currentPassword" [feedback]="false" [toggleMask]="true"></p-password>
</div>
<div class="field">
    <div>New Password:</div>
    <p-password [(ngModel)]="parent.newPassword" [feedback]="false" [toggleMask]="true"></p-password>
</div>
<div class="field">
    <div>Confirm Password:</div>
    <p-password [(ngModel)]="parent.confirmPassword" [feedback]="false" [toggleMask]="true"></p-password>
</div>

<div>
    <button pButton type="button" label="Change Password"
            [disabled]="!parent.currentPassword || !parent.newPassword || !parent.confirmPassword"
            (click)="parent.changePassword()"></button>
</div>
